import { api } from '@/api/index'
import { Loading } from 'element-ui'

let globalLoading;
const state ={
  token: '',
  stashInfo: null,
  teamInfo: null,
  applyOrderInfo: null,
  questInfo: null,
  zcInfo: null,
  indicators: null,
  baseConfig: null,
  applyList: null,
  taskList: null,
  deviceList: null,
  deviceLocations: null,
  querySearchData: null,
  carLocusInfo: null
}
const getters = {}
const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
  },
  GET_STASH_INFO(state, stashInfo) {
    state.stashInfo = stashInfo
  },
  GET_TEAM_INFO(state, teamInfo) {
    state.teamInfo = teamInfo
  },
  GET_APPLY_ORDER_INFO(state, applyOrderInfo){
    state.applyOrderInfo = applyOrderInfo
  },
  GET_QUEST_INFO(state, questInfo) {
    state.questInfo = questInfo
  },
  GET_ZC_INFO(state, zcInfo) {
    state.zcInfo = zcInfo
  },
  GET_INDICATORS(state, indicators) {
    state.indicators = indicators
  },
  GET_CONFIG(state, baseConfig) {
    state.baseConfig = baseConfig
  },
  GET_APPLY_LIST(state, applyList) {
    state.applyList = applyList
  },
  GET_TASK_LIST(state, taskList) {
    state.taskList = taskList
  },
  GET_DEVICE_LIST(state, deviceList) {
    state.deviceList = deviceList
  },
  GET_DEVICE_LOCATIONS(state, deviceLocations) {
    state.deviceLocations = deviceLocations
  },
  SET_CARMARKERINFO(state, querySearchData) {
    state.querySearchData = querySearchData
  },
  GET_PLY_LOCUS(state, carLocusInfo) {
    state.carLocusInfo = carLocusInfo
  }
}
const actions = {
  // fetch warehouse info
  async getStashInfoFn({ commit }) {
    try {
      const stashInfo = await api.getStashInfo();
      if(stashInfo.data) {
        commit('GET_STASH_INFO', stashInfo.data)
      }
    } catch (error) {
      // request error is handled by axios interceptors
    }
  },
  // fetch team info
  async getTeamInfoFn({commit}) {
    try {
      const teamInfo = await api.getTeamInfo();
      if(teamInfo.data){
        commit('GET_TEAM_INFO', teamInfo.data)
      }
    } catch (error) {
      // request error is handled by axios interceptors
    }
  },
  // fetch apply order trend
  async getApplyOrderInfoFn({commit}) {
    try {
      const applyOrderInfo = await api.getApplyOrderInfo();
      if(applyOrderInfo.data) {
        commit('GET_APPLY_ORDER_INFO', applyOrderInfo.data)
      }
    } catch (error) {
      // request error is handled by axios interceptors
    }
  },
  // fetch task trend
  async getQuestInfo({commit}) {
    try {
      const questInfo = await api.getQuestInfo();
      if(questInfo.data) {
        commit('GET_QUEST_INFO', questInfo.data)
      }
    } catch (error) {
      // request error is handled by axios interceptors
    }
  },
  // fetch device status statistics
  async getZCInfo({commit}) {
    try {
      const zcInfo = await api.getZCInfo();
      if(zcInfo.data) {
        commit('GET_ZC_INFO', zcInfo.data)
      }
    } catch (error) {
      // request error is handled by axios interceptors
    }
  },
  // fetch indicator summary
  async getIndicators({commit}) {
    try {
      const indicators = await api.getIndicators()
      if(indicators.data) {
        commit('GET_INDICATORS', indicators.data)
      }
    } catch (error) {
      // request error is handled by axios interceptors
    }
  },
  // fetch base config
  async getConfig({commit}) {
    try {
      const baseConfig = await api.getConfig()
      if(baseConfig.data) {
        commit('GET_CONFIG', baseConfig.data)
      }
    } catch (error) {
      // request error is handled by axios interceptors
    }
  },
  // fetch apply list
  async getApplyList({commit}) {
    try {
      const applyList = await api.getApplyList()
      if(applyList.data) {
        commit('GET_APPLY_LIST', applyList.data)
      }
    } catch (error) {
      // request error is handled by axios interceptors
    }
  },
  // fetch task list
  async getTaskList({commit}) {
    try {
      const taskList = await api.getTaskList()
      if(taskList.data) {
        commit('GET_TASK_LIST', taskList.data)
      }
    } catch (error) {
      // request error is handled by axios interceptors
    }
  },
  // fetch device list
  async getDeviceList({commit}, payload) {
    try {
      const deviceList = await api.getDeviceList(payload)
      if(deviceList.code === 1){
        commit('GET_DEVICE_LIST', deviceList.data)
      }
    } catch (error) {
      // request error is handled by axios interceptors
    }
  },
  // fetch realtime device locations
  async getDeviceLocation({commit}, payload) {
    globalLoading = Loading.service({
      lock: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
      const deviceLocations = await api.getDeviceLocation(payload)
      if (deviceLocations && deviceLocations.code === 1) {
        commit('GET_DEVICE_LOCATIONS', deviceLocations.data)
      }
    } catch (error) {
      // request error is handled by axios interceptors
    } finally {
      if (globalLoading) {
        globalLoading.close()
        globalLoading = null
      }
    }
  },
  // fetch vehicle trajectory
  async getPlyLocus({commit}, payload) {
    globalLoading = Loading.service({
      lock: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
      const carLocusInfo = await api.getPlyLocus(payload)
      if (carLocusInfo && carLocusInfo.code === 1) {
        commit('GET_PLY_LOCUS', carLocusInfo.data)
      }
    } catch (error) {
      // request error is handled by axios interceptors
    } finally {
      if (globalLoading) {
        globalLoading.close()
        globalLoading = null
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

